import { useEffect, useRef } from "react";
import { useNotificacoes } from "shared/hooks/useNotificacoes";

const INTERVALO_SOM = 5000;
const TEMPO_MAXIMO = 10 * 60 * 1000;

export const NotificationSound = () => {
  const { unreadCount } = useNotificacoes();
  const intervaloRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const inicioSomRef = useRef<number | null>(null);
  const temNotificacaoNaoLida = unreadCount > 0;

  useEffect(() => {
    if (!temNotificacaoNaoLida) {
      if (intervaloRef.current) {
        clearInterval(intervaloRef.current);
        intervaloRef.current = null;
      }
      inicioSomRef.current = null;
      return;
    }
    if (intervaloRef.current) return;
    inicioSomRef.current = Date.now();

    const tocarSom = () => {
      if (!inicioSomRef.current) inicioSomRef.current = Date.now();
      const tempoDecorrido = Date.now() - inicioSomRef.current;
      if (tempoDecorrido >= TEMPO_MAXIMO) {
        if (intervaloRef.current) {
          clearInterval(intervaloRef.current);
          intervaloRef.current = null;
        }
        inicioSomRef.current = null;
        return;
      }
      const audio = new Audio("/sounds/move_nova_venda.mp3.mpeg");
      audio.volume = 0.7;
      audio.play().catch(() => {
      });
    };

    tocarSom();
    intervaloRef.current = setInterval(tocarSom, INTERVALO_SOM);

    return () => {
      if (intervaloRef.current) {
        clearInterval(intervaloRef.current);
        intervaloRef.current = null;
      }
    };
  }, [temNotificacaoNaoLida]);

  useEffect(() => {
    return () => {
      if (intervaloRef.current) {
        clearInterval(intervaloRef.current);
        intervaloRef.current = null;
      }
    };
  }, []);

  return null;
};
